import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { SimpleElectricityConnectionPage, SimpleElectricityConnectionPageProps } from "./SimpleElectricityConnectionPage";

export const EMPTY_PAGE_CONTENT: SimpleElectricityConnectionPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/electricity/new-connection/simple";

export const SimpleElectricityConnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<SimpleElectricityConnectionPageProps>("electricity_connection___simple_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <SimpleElectricityConnectionPage {...routeProps} {...content} />;
};
